export const EXTERNAL_LOADING_ROUTES = {
    OPEN_INTERFACE: 'ext.load.module.openinterface',
};
